import { render, staticRenderFns } from "./FileList.vue?vue&type=template&id=f2f88486&"
import script from "./FileList.vue?vue&type=script&lang=ts&"
export * from "./FileList.vue?vue&type=script&lang=ts&"
import style0 from "./FileList.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GDownloadButton from 'shared/global/components/DownloadButton.vue'
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {GDownloadButton,VDataTable,VTooltip})
